import { toISTDate } from '@Apis/constants';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;

  return [
    {
      label: 'Sales Manager',
      value: record?.customer_info?.account_manager_info?.account_manager_id ? (`${record?.customer_info?.account_manager_info?.first_name} ${record?.customer_info?.account_manager_info?.last_name}`) : '-',
    },
    {
      label: 'Tax Id',
      value: record.customer_info?.gst_number ? record.customer_info.gst_number : '-',
    },
    {
      label: 'Linked Vendor',
      value: record?.customer_info?.seller_info?.seller_name || '-',
    },
    {
      label: 'City',
      value: record?.customer_info?.billing_address_details?.city || '-',
    },
    {
      label: 'State',
      value: record?.customer_info?.billing_address_details?.state || '-',
    },
    {
      label: 'Country',
      value: record?.customer_info?.billing_address_details?.country || '-',
    },
    {
      label: 'Created Date',
      value: toISTDate(record?.customer_info?.created_date).format('DD/MM/YYYY'),
    },
  ];
};

export { ListScreenKeys };
